﻿var Handlebars = require('handlebars');
var TimeOfUsageTemplate = require('text-loader!../../js/templates/partials/time_of_usage.partial.template.html');
var AppliancesTemplate = require('text-loader!../../js/templates/partials/appliances.partial.template.html');

Handlebars.registerPartial("time_of_usage_partial", TimeOfUsageTemplate);
Handlebars.registerPartial("appliances_partial", AppliancesTemplate);

Handlebars.registerHelper('if_eq', function(a, b, options) {

    if(a == b) // Or === depending on your needs
        return options.fn(this);
    else
        return options.inverse(this);
});

Handlebars.registerHelper('if_neq', function(a, b, options) {

    if(a != b) // Or === depending on your needs
        return options.fn(this);
    else
        return options.inverse(this);
});

Handlebars.registerHelper('print', function(el, options) {
    console.log(el)
});

Handlebars.registerHelper('getOfArray', function(ar, index, options) {
    if(index+1 > ar.length)
        return "NotFound"; // should not happend
    return ar[index];
});

Handlebars.registerHelper('batSizePlusOne', function(batSizes, options) {
    return batSizes + 1;
});

Handlebars.registerHelper('timePicker', function() {
    var toReturn = "";
    var indexValue = 0;
    for(var i=0; i<24; i++) {
    	for(var j=0; j<6; j++) {
            var hours = i<10 ? "0"+ i : i ;
            var minutes =  j<10 ? (j+"0") : j;

        	toReturn += "<option value='"+ indexValue +"'>" + hours + ":" + minutes + "</option>\n";
            indexValue++;
        }
    }

    return toReturn;
});

Handlebars.registerHelper('decimalDigits', function(number, digits, options) {
    var temp = Math.pow(10, digits);

    if (isNaN(number))
        return "NaN";
    else
        return (Math.round(temp * number) / temp).toFixed(digits);
});







